import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import { useBillingAppendixSetups } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import { billingVouchersEntity } from '@debbie/cortex/dist/billing-vouchers/index.js';
import { casesEntity, useCase } from '@debbie/cortex/dist/cases/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { errorNotification } from '../../../utils/errors.js';
import BillingAppendixSetupSelect from '../../BillingAppendixSetupSelect.js';
import BillingModelSelect from '../../BillingModelSelect.js';
import OngoingWork from '../../economy/OngoingWork.js';
import GenericSelector from '../../GenericSelector.js';
import { Col, Row } from '../../Grid/index.js';
import ExternalLink from '../../Icons/ExternalLink.js';
import { Badge, DateInput, Modal, PlaceholderLoader, Well, } from '../../index.js';
import BillingAppendixSetup from '../BillingAppendixSetup.js';
import BillingModel from '../BillingModel/BillingModel.js';
import Billings from '../Billings.js';
const CaseBillingModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable)
        ? billingModelsLoadable.data
        : null;
    const [billingModelId, setBillingModelId] = useState(null);
    const [billingStartDate, setBillingStartDate] = useState(null);
    const [billingAppendixSetupId, setBillingAppendixSetupId] = useState(null);
    const updateBillingStartDateMutation = useMutation((date) => casesAPI.patch(props.caseId, {
        billingStartDate: date ? date.startOf('day').format() : null,
    }), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(casesEntity, props.caseId));
        },
        onError: (err) => {
            // Reset to original value on error
            if (singleCase) {
                setBillingStartDate(singleCase.billingStartDate
                    ? moment(singleCase.billingStartDate)
                    : null);
            }
            errorNotification(lang, err, 'update', lang.errorEntities.case);
        },
    });
    useEffect(() => {
        if (singleCase) {
            setBillingModelId(singleCase.billingModelId);
            setBillingStartDate(singleCase.billingStartDate
                ? moment(singleCase.billingStartDate)
                : null);
            setBillingAppendixSetupId(singleCase.billingAppendixSetupId);
        }
    }, [singleCase]);
    return (React.createElement(Modal, { onToggle: props.onToggle, maxWidth: "1200px", header: lang.clientBilling.clientBilling },
        billingModels && singleCase ? (React.createElement(Well, null,
            singleCase.tags.length > 0 && (React.createElement(Row, { style: { marginBottom: '15px' } }, singleCase.tags.map((tag) => (React.createElement(Badge, { key: tag.tag, theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } },
                lang.caseTags[tag.tag] || tag.tag,
                tag.from || tag.to
                    ? ` (${tag.from
                        ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                        : '∞'} - ${tag.to
                        ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT)
                        : '∞'})`
                    : ''))))),
            React.createElement(Row, null,
                React.createElement(Col, { width: "4" },
                    React.createElement(BillingModelSelector, { singleCase: singleCase })),
                React.createElement(Col, { width: "4" },
                    React.createElement(DateInput, { placeholder: "Start afregning af indbetalinger fra", allowNull: true, value: billingStartDate, onChange: (date) => {
                            setBillingStartDate(date);
                            updateBillingStartDateMutation.mutate(date);
                        } })),
                React.createElement(Col, { width: "4" },
                    React.createElement(BillingAppendixSetupSelector, { singleCase: singleCase }))))) : (React.createElement(PlaceholderLoader, null)),
        React.createElement("h3", null, lang.billing.ongoingWork),
        React.createElement(OngoingWork, { caseId: props.caseId, highlightCaseId: props.caseId }),
        React.createElement("h3", null, lang.billing.bills),
        React.createElement(Billings, { caseId: props.caseId, highlightCaseId: props.caseId })));
};
export default CaseBillingModal;
const BillingModelSelector = (props) => {
    return (React.createElement(GenericSelector, { id: props.singleCase.billingModelId, mutationFn: async (id) => {
            await casesAPI.patch(props.singleCase.caseId, {
                billingModelId: id,
            });
            q.invalidate([
                ...keys.write.modify(casesEntity, props.singleCase.caseId),
                ...keys.write.create(billingVouchersEntity),
            ]);
        }, preview: () => {
            const lang = useSelector((s) => s.lang);
            const [show, setShow] = useState(false);
            const billingModelsLoader = useBillingModels();
            const billingModel = (h.hasData(billingModelsLoader) ? billingModelsLoader.data : []).find((bm) => bm.billingModelId === props.singleCase.billingModelId);
            return (React.createElement(React.Fragment, null,
                show && billingModel ? (React.createElement(Modal, { maxWidth: "1200px", header: React.createElement(React.Fragment, null,
                        lang.economy.newBillingModel,
                        ' ',
                        React.createElement(ExternalLink, { style: {
                                cursor: 'pointer',
                                float: 'none',
                            }, onClick: () => c.redirect.redirect(`/settings/economy/billing/billing-models/${billingModel.billingModelId}`) })), onToggle: () => setShow(false) },
                    React.createElement(BillingModel, { billingModel: billingModel }))) : null,
                React.createElement(PreviewText, { onClick: () => {
                        setShow(true);
                    } }, lang.billingModels.previewBillingModel)));
        } }, (select) => React.createElement(BillingModelSelect, { ...select })));
};
const BillingAppendixSetupSelector = (props) => {
    return (React.createElement(GenericSelector, { id: props.singleCase.billingAppendixSetupId, mutationFn: async (id) => {
            await casesAPI.patch(props.singleCase.caseId, {
                billingAppendixSetupId: id,
            });
            q.invalidate([
                ...keys.write.modify(casesEntity, props.singleCase.caseId),
                ...keys.write.create(billingVouchersEntity),
            ]);
        }, preview: () => {
            const lang = useSelector((s) => s.lang);
            const [show, setShow] = useState(false);
            const billingAppendixSetupsLoader = useBillingAppendixSetups();
            const billingAppendixSetup = (h.hasData(billingAppendixSetupsLoader)
                ? billingAppendixSetupsLoader.data
                : []).find((bm) => bm.billingAppendixSetupId ===
                props.singleCase.billingAppendixSetupId);
            return (React.createElement(React.Fragment, null,
                show && billingAppendixSetup ? (React.createElement(Modal, { maxWidth: "1200px", header: React.createElement(React.Fragment, null,
                        lang.economy.billingAppendixSetup,
                        ' ',
                        React.createElement(ExternalLink, { style: {
                                cursor: 'pointer',
                                float: 'none',
                            }, onClick: () => c.redirect.redirect(`/settings/economy/billing/billing-appendix-setups/${billingAppendixSetup.billingAppendixSetupId}`) })), onToggle: () => setShow(false) },
                    React.createElement(BillingAppendixSetup, { billingAppendixSetup: billingAppendixSetup }))) : null,
                React.createElement(PreviewText, { onClick: () => {
                        setShow(true);
                    } }, lang.billingAppendixSetups.previewBillingAppendixSetup)));
        } }, (select) => React.createElement(BillingAppendixSetupSelect, { ...select })));
};
const PreviewText = styled.p `
  margin: 0;
  font-size: 0.8em;
  font-weight: bold;
  color: ${THEME.COLOR_ACCENT};
  cursor: pointer;
`;
//# sourceMappingURL=CaseBillingModal.js.map